import { ModuleStateEnum, PausedStateEnum } from "./module-state.enum";

export const isPausedState = (state: ModuleStateEnum): boolean => {
  return [...(Object.values(PausedStateEnum) as string[])].includes(state);
};
